import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { Injectable, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { BusinessTripEventRemoteActionType } from './btrip-events-remote-action-type';
import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { CarSelectRaStepComponent } from 'src/app/_components/remote-action-step/car-select-ra-step/car-select-ra-step.component';
import { JobSectionSelectRaStepComponent } from 'src/app/_components/remote-action-step/jobsection-select-ra-step/jobsection-select-ra-step.component';
import { EmpSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/emp-select-remote-action-builder-ui-step/emp-select-remote-action-builder-ui-step';

@Injectable()
export class BusinessTripEventRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private type: BusinessTripEventRemoteActionType,
    private clientStateService: ClientStateService,
    appService: AppService,
    credentialsService: CredentialsService,
    locationService: LocationService,
    employeeService: EmployeeService,
    private appParameterService: AppParameterService,
    private logger?: LoggingService
  ) {
    super(
      type.pageTitle,
      appService,
      credentialsService,
      {
        endpoint: type.endpoint,
        data: {},
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: type.raShortLabel,
        shortLabelTranslate: true,
      },
      []
        .concat(
          appParameterService.appParameters$
            .getValue()
            ?.getBooleanParameter(
              'imsmc.worktypeselect.showempselection',
              true
            ) && !employeeService.onlyMeInTeam()
            ? [new EmpSelectRemoteActionBuilderUiStep(logger)]
            : []
        )
        .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)]),
      [
        new TeamRemoteActionBuilderServiceStep(
          employeeService,
          clientStateService,
          logger
        ),
        new GpsRemoteActionBuilderServiceStep(locationService, logger),
      ],
      async (data: any) => {
        this.logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );

        switch (type) {
          case BusinessTripEventRemoteActionType.START_OF_STEERING_PAUSE:
            await this.clientStateService.startSteeringBreak();
            break;
          case BusinessTripEventRemoteActionType.END_OF_STEERING_PAUSE:
            await this.clientStateService.endSteeringBreak();
            break;
          case BusinessTripEventRemoteActionType.START_OF_RESTING_PAUSE:
            await this.clientStateService.startRestingBreak();
            break;
          case BusinessTripEventRemoteActionType.END_OF_RESTING_PAUSE:
            await this.clientStateService.endRestingBreak();
            break;
        }
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    return super.generateRemoteAction(dataValues);
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    // Configure specific Components
    if (componentRef.instance instanceof TimeCorrectionComponent) {
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        this.type.descriptionKey
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        this.type.titleKey
      );

      const appParams = this.appParameterService.appParameters$.getValue();
      if (appParams != undefined) {
        switch (this.type) {
          case BusinessTripEventRemoteActionType.START_OF_STEERING_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sosp',
                false
              );
            break;
          case BusinessTripEventRemoteActionType.END_OF_STEERING_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eosp',
                false
              );
            break;
          case BusinessTripEventRemoteActionType.START_OF_RESTING_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.sorp',
                false
              );
            break;
          case BusinessTripEventRemoteActionType.END_OF_RESTING_PAUSE:
            (<TimeCorrectionComponent>componentRef.instance).hideComment =
              appParams.getBooleanParameter(
                'imsmc.remoteaction-step.hidecomment.eop',
                false
              );
            break;
        }
      }
    }

    return componentRef;
  }
}
